<template>
<v-main>
    <video controls class="info-video" style="width: 100vw; margin-bottom: 50px;">
        <source :src="require('@/assets/CONOCELES_VIDEO.mp4')" type="video/mp4"/>
    </video>
</v-main>
</template>